import React from "react";
import { string, func } from "prop-types";
import LinkNativeCapture from "../LinkNativeCapture";
import LinkSelectCamera from "../LinkSelectCamera";
import "./style.css";

NativeCaptureBox.propTypes = {
  facingMode: string,
  onUploaded: func,
};

export default function NativeCaptureBox(props) {
  return (
    <div className="native-capture-box box-shadow">
      Having problems?
      <span className="nativeClose" onClick={props.handleHideNative}>
        X
      </span>
      <div>
        {props.cameraSelection ? (
          <div style={{ display: "inline" }}>
            <LinkSelectCamera {...props} />
          </div>
        ) : null}
        <LinkNativeCapture {...props} />
      </div>
    </div>
  );
}
